export const container = ({ square }) => ({
    position: 'relative',
    width: '100%',
    height: square && '100%',
});

export const video = ({ square }) => ({
    width: '100%',
    height: square && '100%',
    objectFit: 'cover',
});
